// extracted by mini-css-extract-plugin
export default {"cls1":"UserCard-cls1__aU","cls2":"UserCard-cls2_gez UserCard-cls1__aU"};